import axios from "axios";

let httpLink = 'https://appstest.cibercolegios.com/api/vendor_security';
//let httpLink = 'http://localhost:8080';

if (process.env.REACT_APP_ENV === "prod") {
    httpLink = 'https://appsprod.cibercolegios.com/api/vendor_security';
} else if (process.env.REACT_APP_ENV === "migracion") {
    httpLink = 'https://migracionappsprod.cibercolegios.com/api/vendor_security';
} 

export const sessionStart=(token)=>{
    return axios.get(httpLink+ '/public/session-start/', {
        headers: {
            'auth_token': token
        }
    });
};